import {
  GridPortalWrapper,
  QuickFilter,
  QuickFilterControl,
} from "@mui/x-data-grid-pro";
import { SearchBar } from "@flat-ui";

/** Wrapper to show the quick search toolbar */
export function QuickSearchToolbar(): React.JSX.Element {
  return (
    <GridPortalWrapper>
      <QuickFilter expanded>
        <QuickFilterControl
          render={({ ref, value, onChange }) => (
            <SearchBar
              controlStyle={{
                width: 260,
                "& .MuiInputBase-input": { py: 1 },
                "& > .MuiStack-root": { display: "none" },
              }}
              inputRef={ref}
              text={typeof value === "string" ? value : ""}
              onTextChanged={(text: string) =>
                onChange?.({
                  target: { value: text },
                } as React.ChangeEvent<HTMLInputElement>)
              }
              onSearchReset={() =>
                onChange?.({
                  target: { value: "" },
                } as React.ChangeEvent<HTMLInputElement>)
              }
              placeholder="Search..."
              autoFocus
            />
          )}
        />
      </QuickFilter>
    </GridPortalWrapper>
  );
}
